export class AdminEmpty {}
